import { render } from "./DashboardShell.vue?vue&type=template&id=f7bf90ba&scoped=true"
import script from "./DashboardShell.vue?vue&type=script&lang=js"
export * from "./DashboardShell.vue?vue&type=script&lang=js"

import "./DashboardShell.vue?vue&type=style&index=0&id=f7bf90ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7bf90ba"]])

export default __exports__